import { useState, useCallback, useRef } from "react";
import Webcam, { WebcamProps } from "react-webcam";

type UseWebcamReturnType = {
  camPic: string;
  capture: () => void;
  closeCamera: () => void;
  webcamRef: React.RefObject<Webcam>;
  cameraPermission: boolean;
  setCameraPermission: (cameraPermission: boolean) => void;
};

const useWebcam = (): UseWebcamReturnType => {
  const [camPic, setCamPic] = useState<string>("");
  const webcamRef = useRef<Webcam>(null);
  const [cameraPermission, setCameraPermission] = useState(true);

  const checkCameraPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      // Permission granted
      setCameraPermission(true);
      console.log({ cameraPermission: "is Granted" });

      stream.getTracks().forEach((track) => track.stop());
    } catch (error) {
      // Permission denied
      setCameraPermission(false);
      console.log({ cameraPermission: "is Denied" });
    }
  };

  const capture = useCallback(() => {
    const pictureSrc = webcamRef.current?.getScreenshot();
    checkCameraPermission();

    if (pictureSrc) {
      setCamPic(pictureSrc);
    }
  }, []);

  const closeCamera = useCallback(() => {
    if (webcamRef.current) {
      webcamRef.current.video?.pause();
      const stream = webcamRef.current.video?.srcObject as MediaStream;
      stream?.getTracks().forEach((track) => {
        track.stop();
      });
    }
  }, []);

  return {
    camPic,
    capture,
    closeCamera,
    webcamRef,
    cameraPermission,
    setCameraPermission,
  };
};

export default useWebcam;

// const checkCameraAccess = async () => {
//   try {
//     await navigator.mediaDevices.getUserMedia({ video: true });
//     setHasCameraAccess(true);
//   } catch (error) {
//     alert("Please allow camera access to continue the test");
//     setHasCameraAccess(false);
//   }
// };
